module.exports = __webpack_public_path__ + "img/221122-bimistock-image-12-----@1x.84f073c6.png";